//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions } from "vuex";

export default {
  name: "addInstagramModal",

  computed: {
    validInput() {
      return (
        this.contentName &&
        this.numOfPosts > 0 &&
        this.numOfPosts < 26 &&
        this.displayDurationInSeconds > 0
      );
    },
  },

  data() {
    return {
      msg: "Add Instagram",
      numOfPosts: 3,
      displayDurationInSeconds: 10,
      contentName: "",
      autoUpdate: false,
    };
  },

  methods: {
    ...mapActions(["addInstagramContent", "setFBToken"]),

    postToBackend() {
      this.addInstagramContent({
        duration: this.displayDurationInSeconds,
        numberOfPosts: this.numOfPosts,
        name: this.contentName,
        isAutoUpdate: this.autoUpdate ? 1 : 0,
      }).then((response) => {
        if (!response) {
          // clear insta token if token expired
          this.setFBToken("");
        }
      });
    },

    // following method is REQUIRED
    // (don't change its name --> "show")
    show() {
      this.$refs.dialog.show();
    },

    // following method is REQUIRED
    // (don't change its name --> "hide")
    hide() {
      this.$refs.dialog.hide();
    },

    onDialogHide() {
      // required to be emitted
      // when QDialog emits "hide" event
      this.$emit("hide");
    },

    onOKClick() {
      // on OK, it is REQUIRED to
      // emit "ok" event (with optional payload)
      // before hiding the QDialog
      this.$emit("ok");
      // or with payload: this.$emit('ok', { ... })

      // then hiding dialog
      this.hide();
    },

    onCancelClick() {
      // we just need to hide dialog
      this.hide();
    },
  },
};
